import { render, staticRenderFns } from "./screenDetails.vue?vue&type=template&id=5c198dfc&scoped=true&"
import script from "./screenDetails.vue?vue&type=script&lang=js&"
export * from "./screenDetails.vue?vue&type=script&lang=js&"
import style0 from "./screenDetails.vue?vue&type=style&index=0&id=5c198dfc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c198dfc",
  null
  
)

export default component.exports